export enum LocationAddressType {
  AddressAndCoords = 'address-and-coords',
  PlusCode = 'plus-code',
  CustomTextOnly = 'custom-text-only',
}
